module.exports = __webpack_public_path__ + "img/gold.3310c46b.svg";